module.exports = __webpack_public_path__ + "static/media/tractor.b4eec928.svg";